import React, { Component } from 'react';
import Coins from '../../components/Coins';
import { message } from 'antd';

class AssetList extends Component {
	render() {
		const { createWallet, coin } = this.props;
		const List = coin.map((item) => {
			return (
				<Coins
					small={true}
					large={true}
					type={item.value}
					onClick={() => {
						if (item.disabled) {
							message.info(
								'XMR requires custom setup. Please contact us at support@hollaex.com to setup your XMR wallet'
							);
						} else {
							createWallet(item.value);
						}
					}}
					{...item}
				/>
			);
		});
		return (
			<div className="wallet-list">
				<div>
					<h2>
						<b>Asset List</b>
					</h2>
					<p>Pick the asset you want to create a wallet for below:</p>
				</div>
				<div className="coin-list">{List}</div>
			</div>
		);
	}
}

export default AssetList;
